import { render, staticRenderFns } from "./NpsRatingModal.vue?vue&type=template&id=047fdf06&"
import script from "./NpsRatingModal.vue?vue&type=script&lang=js&"
export * from "./NpsRatingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports